import { truncate, uniq } from 'lodash'

export const getDynamicOptions = (rows, schema) => {
  const uniqueOptions = uniq(rows.map((row) => row[schema.accessor]?.value || row[schema.accessor]))

  const formattedOptions = uniqueOptions.map((option) => {
    const matchingRows = rows.filter((row) => {
      return (row[schema.accessor]?.value || row[schema.accessor]) === option
    })

    return {
      label: option,
      value: option,
      meta: {
        rowData: matchingRows[0], // return first matching row if consumer wants it
      },
    }
  })

  return formattedOptions
}

export const getFilterPopupLabel = (type, value, hasValue, label) => {
  if (type === 'text') {
    if (hasValue) {
      return `Searching: ${truncate(value, { length: 30 })}`
    }

    return `Search ${label}`
  }

  if (type === 'select' || type === 'multiSelect') {
    if (hasValue) {
      return typeof label === 'string'
        ? `Filtering by: ${truncate(label, { length: 30 })}`
        : 'Filtering'
    }

    return `Filter ${label}`
  }

  return 'Search'
}

export const getAllNodeIDs = (node, key = 'value') => {
  let values = [node[key]]

  if (Array.isArray(node.children)) {
    for (const child of node.children) {
      values = values.concat(getAllNodeIDs(child, key))
    }
  }
  return values
}

export const getNodeWithChildrenIDs = (selectedID, options, key = 'value') => {
  if (options[key] === selectedID) {
    return [
      selectedID,
      ...(options.children?.flatMap((child) => getNodeWithChildrenIDs(child[key], child, key)) ||
        []),
    ]
  }
  return options.children?.flatMap((child) => getNodeWithChildrenIDs(selectedID, child, key)) || []
}

export const findNodeByValue = (node, value, key = 'value') => {
  if (node[key] === value) {
    return node
  }

  if (Array.isArray(node.children)) {
    for (const child of node.children) {
      const found = findNodeByValue(child, value, key)
      if (found) {
        return found
      }
    }
  }

  return null
}
